var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('h1',[_vm._v("Questions Fréquentes sur le Shiatsu Thérapeutique")]),_c('section',{staticClass:"section-faq"},_vm._l((_vm.faqs),function(faq,index){return _c('Faq',{key:`Definition : ${faq.question}`,attrs:{"index":index,"definition":faq}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }